import request from '@/utils/request'

// 获取活动详情
export function getActionInfo() {
    return request({
        method: 'POST',
        url: `/action/getActionInfo`,
    })
}
export function getdingdingtoken(data) {
    return request({
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        url: `/dingding/gettoken`,
        params: data
    })
}